<template>
  <div class="productividad-comercial">
    <details class="simple" open>
      <summary>INDICADORES CLAVE</summary>
      <div class="pr-first-row">
        <div class="pr-item info">
          <div><b>Productividad</b></div>
          <div class="big-number">{{ ratioProductividad }}%</div>
        </div>
        <Promedio caption="Ganadas" variant="success" :promedio="promedioGanadas" :recuento="recuentoGanadas" />
        <Promedio caption="Perdidas" variant="danger" :promedio="promedioPerdidas" :recuento="recuentoPerdidas" />
        <Promedio caption="Caducadas" variant="danger" :promedio="promedioCaducadas" :recuento="recuentoCaducadas" />
        <Promedio
          caption="Pendientes"
          variant="warning"
          :promedio="promedioPendientes"
          :recuento="recuentoPendientes"
        />
        <Promedio caption="Total Ofertas" variant="info" :promedio="promedioGeneral" :recuento="recuentoTotal" />
      </div>
      <div class="pr-second-row">
        <div class="pr-item primary">
          <b>Cuota Anual</b>
          <div class="big-number">{{ totalCuotaAnual }}</div>
        </div>
        <div class="pr-item primary">
          <b>Servicios</b>
          <div class="big-number">{{ totalServicios }}</div>
        </div>
        <div class="pr-item info analisis-links" v-if="esAdmin">
          <b-link to="/ofertas/analisis-productividad-comercial">
            <b-icon icon="bar-chart-fill" />
            Análisis detallado
          </b-link>
          <b-link to="/ofertas/analisis-pronostico-comercial">
            <v-icon name="activity" width="16" />
            Pronóstico
          </b-link>
          <b-link to="/ofertas/analisis-por-modulos">
            <v-icon name="package" width="16" />
            Análisis módulos
          </b-link>
        </div>
      </div>
    </details>
  </div>
</template>
<script>
import { mapState } from "pinia";
import { useSessionStore } from "@/stores/SessionStore";
import { productividadComercial } from "@/services/productividadComercial.js";
import Promedio from "./Promedio.vue";

function euroFormat(v) {
  return new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(v);
}

function promedioFormat(v) {
  return new Intl.NumberFormat("es-ES", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(v);
}

function ratioFormat(v) {
  return new Intl.NumberFormat("es-ES", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(v);
}

export default {
  components: {
    Promedio,
  },
  computed: {
    ...mapState(useSessionStore, ["esAdmin"]),
  },
  data() {
    return {
      recuentoTotal: 0,
      recuentoGanadas: 0,
      recuentoPerdidas: 0,
      recuentoPendientes: 0,
      recuentoCaducadas: 0,
      promedioGanadas: 0,
      promedioPerdidas: 0,
      promedioPendientes: 0,
      promedioCaducadas: 0,
      promedioGeneral: 0,
      totalCuotaAnual: 0,
      totalServicios: 0,
      ratioProductividad: 0,
    };
  },
  methods: {
    async cargarProductividad(params) {
      const data = await productividadComercial(params);
      this.recuentoTotal = data.recuentoTotal;
      this.recuentoGanadas = data.recuentoGanadas;
      this.recuentoPerdidas = data.recuentoPerdidas;
      this.recuentoPendientes = data.recuentoPendientes;
      this.recuentoCaducadas = data.recuentoCaducadas;
      this.promedioGanadas = promedioFormat(data.promedioGanadas);
      this.promedioPerdidas = promedioFormat(data.promedioPerdidas);
      this.promedioPendientes = promedioFormat(data.promedioPendientes);
      this.promedioCaducadas = promedioFormat(data.promedioCaducadas);
      this.promedioGeneral = promedioFormat(data.promedioGeneral);
      this.totalCuotaAnual = euroFormat(data.totalCuotaAnual);
      this.totalServicios = euroFormat(data.totalServicios);
      this.ratioProductividad = ratioFormat(data.ratioProductividad);
    },
  },
};
</script>
<style>
.pr-first-row {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 1rem;
  margin-bottom: 1rem;
}

.big-number {
  font-size: 1.5rem;
  font-weight: bold;
}

.pr-second-row {
  display: grid;
  grid-template-columns: repeat(3, 2fr);
  gap: 1rem;
}

.pr-item {
  flex: 1 1 150px;
  padding: 1rem;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: #d2e4f1;
  color: #222;
}

.pr-item.success {
  background-color: #d4edda;
  color: #155724;
}
.pr-item.info {
  background-color: #d1ecf1;
  color: #0c5460;
}
.pr-item.danger {
  background-color: #f8d7da;
  color: #721c24;
}
.pr-item.warning {
  background-color: #fff3cd;
  color: #856404;
}
.pr-item.secondary {
  background-color: #e2e3e5;
  color: #383d41;
}

.pr-item.primary {
  background-color: #cce5ff;
  color: #004085;
}

.promedio {
  font-size: 0.9rem;
  background: #95e295;
  color: #02320e;
  padding: 0.2rem 0.4rem;
  border-radius: 3px;
  float: right;
}

.recuento {
  font-size: 1.5rem;
  font-weight: bold;
}
.analisis-links a {
  display: block;
  margin-top: 0.5rem;
}
</style>
